var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{staticClass:"SvgArrow",attrs:{"d":_vm.path,"fill":_vm.color,"transform":("rotate(" + _vm.angle + ")")}})}
var staticRenderFns = []

export { render, staticRenderFns }